import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { useAppStore } from "@/global/store";
import { gameFiltersState } from "@/global/store/data/gameFilters";
import { IosSwitch } from "@/shared/base/components/IosSwitch/IosSwitch";
import { Box, FormControlLabel, Slider, Typography } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { useFilterPanelsState } from "../useFilterPanels";
import { filterPanelNames } from "@/global/config/constants";

export function AccessibilitySelector(props: {
  title?: string;
  description?: string;
  customLabel?: string | React.ReactNode;
}) {
  const dispatch = useDispatch();
  const teamConfig = useTeamConfig();
  const isAda = useAppStore((s) => s.data.gameFilters.accessibility.isAda);
  const { set: setFilterPanelsState } = useFilterPanelsState();

  const handleUpdateAda = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(
      gameFiltersState.actions.setByKeys({
        keys: ["accessibility", "isAda"],
        value: event.target.checked,
      })
    );
    setFilterPanelsState({
      lastChangedFilter: filterPanelNames.accessibility_selector,
    });
  };

  return (
    <Box>
      {props?.title ? (
        <Box>
          <Typography
            variant="subtitle1"
            fontWeight={"700"}
            color="text.primary"
          >
            {props?.title}
          </Typography>
        </Box>
      ) : null}

      {props?.description ? (
        <Box>
          <Typography variant="body1" color="text.primary">
            {props?.description}
          </Typography>
        </Box>
      ) : null}

      {!teamConfig?.uiConfigs?.gameFiltersSettings
        ?.hideAccessibilityRadioButton ? (
        <Box mt={2}>
          {props?.customLabel ? (
            typeof props?.customLabel === "object" ? (
              props?.customLabel
            ) : (
              <Typography
                variant="body1"
                color="text.primary"
                dangerouslySetInnerHTML={{
                  __html: props?.customLabel,
                }}
              />
            )
          ) : (
            <Box ml={1}>
              <FormControlLabel
                control={
                  <IosSwitch checked={isAda} onChange={handleUpdateAda} />
                }
                label={"Only show ADA compliant seats"}
              />
            </Box>
          )}
        </Box>
      ) : null}
    </Box>
  );
}
